var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('div',{style:({width: _vm.report.width, height: _vm.report.height}),attrs:{"id":_vm.report.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }